const PREFIXES = ['', 'k', 'M', 'G', 'T', 'P', 'E'];

/**
 * Return prefix position & formatted number
 * @param num
 * @param i
 * @returns {{num, index}|{num: *, index: number}}
 */

const findFormat = (num, i = 0) => {
    const metricNum = num / 1000;
    if (metricNum < 1) {
        return { index: i, num };
    }
    return findFormat(metricNum, i + 1);
};

/**
 * Format numbers & add metric prefixes
 *
 * 999 => 999
 * 9999 => 9.9K
 * 9999999 => 9.9M
 *
 * @type {Function}
 * @param {Number} number - input value
 * @param {Number} decimals - number of decimal digits
 */

export const metricNumber = (number, decimals = 1) => {

    const isNumber = !isNaN(parseFloat(number)) && isFinite(number);

    if (number < 1000 || !isNumber) {
        return number;
    }

    const { index, num } = findFormat(number);

    return num.toString().replace(new RegExp(`(\\.\\d{${decimals}})\\d*`), '$1') + PREFIXES[index];
};
